'use client'
// import { useEffect, useState, useMemo, type FC } from 'react'
import { useParams } from 'next/navigation'
// import { useForm, type SubmitHandler } from 'react-hook-form'
import styled from 'styled-components'
import { useTranslator } from '@/hooks'
// import { autoComplete, inputPattern, cookie } from '@/utils'
// import { Button } from '..'
// import { Input, Checkbox } from '../inputs'
// import { MODALS } from '@/context'
// import { useModal } from '@/hooks'
// import { mq, vw  } from '@/styles'
// import { GraphQlErrors } from './GraphQlErrors'
// import { DisplayError } from './DisplayError'

// type TypeFormInputs = {
//   name: string
//   email: string
//   password: string,
//   acceptTerms: boolean
// }

// function getExpiryDate(): string {
//   const date = new Date()
//   date.setHours(date.getHours() + 6)
//   return date.toISOString()
// }

const MESSAGE_TRANSLATION = {
  de: '<p>💫 Aicam war ein bahnbrechendes KI-Experiment von <a href="https://you.digital" target="_blank" rel="noopener noreferrer">Digital You</a> aus dem Jahr 2023 - damals noch reine Science-Fiction. Wir halten es aus nostalgischen Gründen 🥰 im „Museumsmodus“ online. </p>',
  en: '<p>💫 Aicam was a pioneer AI experiment by <a href="https://you.digital" target="_blank" rel="noopener noreferrer">Digital You</a> in 2023, when this was sci-fi. We keep it online in “museum mode” for nostalgic reasons 🥰.</p>',
  es: '<p>💫 Aicam fue un experimento pionero de IA creado por <a href="https://you.digital" target="_blank" rel="noopener noreferrer">Digital You</a> en 2023, cuando esto aún era ciencia ficción. Lo mantenemos online en “modo museo” por nostalgia 🥰.</p>',
  fr: '<p>💫 Aicam était une expérience d\'IA pionnière créée par <a href="https://you.digital" target="_blank" rel="noopener noreferrer">Digital You</a> en 2023, à l\'époque où tout cela relevait encore de la science-fiction. Nous la gardons en ligne en “mode musée” par pure nostalgie 🥰.</p>',
  it: '<p>💫 Aicam è stato un esperimento pionieristico di IA creato da <a href="https://you.digital" target="_blank" rel="noopener noreferrer">Digital You</a> nel 2023, quando tutto questo era ancora fantascienza. Lo manteniamo online in “modalità museo” per nostalgia 🥰.</p>',
  pt: '<p>💫 Aicam foi uma experiência pioneira de IA criada pela <a href="https://you.digital" target="_blank" rel="noopener noreferrer">Digital You</a> em 2023, quando isso ainda era ficção científica. Mantemos o site online em “modo museu” por nostalgia 🥰.</p>',
}

export const FormAuthSignUp = () => {
  // const { register, handleSubmit, formState: { errors: formErrors }, setValue, watch } = useForm<TypeFormInputs>()
  // const { payload } = useModal(MODALS.AUTH)
  const { lang } = useParams()
  const { t } = useTranslator()
  // const router = useRouter()
  // const { setLoaderActive } = useSession()
  // const watchAcceptTerms = watch('acceptTerms')
  // const watchEmail = watch('email')
  // const watchPassword = watch('password')
  // const [apiErrors, setApiErrors] = useState(null)
  // const anchorComponent = useMemo(() => <a href='/rules-and-privacy'>{t('commons.actions.read')}</a>, [t])

  // useEffect(() => {
  //   if(payload) {
  //     setValue('email', payload)
  //   }
  // }, [payload, setValue])

  // const onSubmit: SubmitHandler<TypeFormInputs> = async (formData) => {
  //   setLoaderActive(true)
  //   try {
  //     const res = await fetch('/api/auth/signup', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json'
  //       },
  //       body: JSON.stringify({ ...formData, lang })
  //     })

  //     if (!res.ok) throw new Error('FormAuthSignup submit failed')
  //     if (res.status === 200) {
  //       const data = await res.json()
  //       if(Array.isArray(data.errors) && data.errors.length > 0) {
  //         console.log('data.errors', data.errors)
  //         setLoaderActive(false)
  //         setApiErrors( data.errors)
  //         return
  //       }

  //       if (data?.data?.userRegister && data.data.userRegister?.ok) {
  //         setApiErrors(null)
  //         const { token, expiryDate } = data.data.userRegister
  //         const expiryDateUpdated =  typeof expiryDate === 'string' ? expiryDate : getExpiryDate()
  //         const isHidden = localStorage.getItem('isHidden')
  //         if(isHidden) localStorage.removeItem('isHidden')
  //         cookie.set('DY_AICAM_USER', token, { maxAge: getMaxAge(expiryDateUpdated) })
  //       }
  //       setLoaderActive(false)
  //       alert(t('auth.signup.feedback_success'))
  //       router.push(`/${lang}/projects?signup=true`)
  //     }
  //   } catch (e) {
  //     setLoaderActive(false)
  //     setApiErrors(e)
  //     console.warn('Login submit - Catch e', e)
  //   }
  // }

  return (
    <>
      {/* <Form onSubmit={handleSubmit(onSubmit)}> */}
      <Form>
        <div className='msg' dangerouslySetInnerHTML={{ __html: MESSAGE_TRANSLATION[lang as string || 'en'] }} />
        <GoBack href='/'>{t('commons.actions.go_back')}</GoBack>
      </Form>
    </>
  )
}

const Form = styled.form`
  width: 90%;
`
const GoBack = styled.a`
  display: block;
  text-align: center;
  background: none;
  width: 100%;
  color: var(--color-text);
  text-decoration: underline;
`

// const ErrorsWrapper = styled.ul`
//   margin: 0 auto ${vw(20, 'mobile')};
//   padding: 0 ${ vw(4.25, 'mobile') };
//   width: 95%;

//   ${mq.greaterThan('nexus7')} {
//     margin: 0 auto ${vw(20, 'tablet')};
//     padding: 0 ${ vw(4.25, 'tablet') };
//   }

//   ${mq.greaterThan('tablet') } {
//     margin: 0 auto ${vw(30, 'desktop')};
//     padding: 0 ${vw(12.5, 'desktop')};
//   }

//   ${mq.greaterThan('desktop')} {
//     margin: 0 auto 30px;
//     padding: 0 12.5px;
//   }
// `

// const getMaxAge = (dateString: string): number => {
//   // Parse the date string into a Date object
//   const date = new Date(dateString)

//   // Calculate the time difference between the parsed date and the current date
//   const currentTime = new Date()
//   const timeDifferenceMilliseconds = date.getTime() - currentTime.getTime()

//   // Convert the time difference to seconds for maxAge
//   const maxAgeSeconds = Math.floor(timeDifferenceMilliseconds / 1000)
//   return maxAgeSeconds
// }
